import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "rea_session_token";

export const http = axios.create({ baseURL: API });
http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(KEY);
  if (t) cfg.headers["X-Session-Token"] = t;
  return cfg;
});

export async function ensureSession() {
  if (localStorage.getItem(KEY)) {
    try {
      const { data } = await http.get("/session");
      return data;
    } catch (e) {
      if (e?.response?.status !== 401) throw e;
    }
  }
  const { data } = await http.post("/session");
  localStorage.setItem(KEY, data.token);
  return { credits: 0, investigations: [] };
}

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";

export const IMAGES = {
  rea: "https://static.prod-images.emergentagent.com/jobs/a3a9839e-e55f-4496-972b-70597ef12d5c/images/14fec4e42ae9235ddf55f41ac6f4f5ab494e9ccb3ab3a807ccf3b29ca7f16eb6.jpeg",
  paywall: "https://static.prod-images.emergentagent.com/jobs/a3a9839e-e55f-4496-972b-70597ef12d5c/images/74df97c9b79b73e0695424591d80da1fe405c15e7fb08f09d171b304c670562c.jpeg",
  scan: "https://static.prod-images.emergentagent.com/jobs/a3a9839e-e55f-4496-972b-70597ef12d5c/images/65bbd448999e7e8c03b7886c1010995b4708a800e5f6a7e454fc3f7185a0759f.jpeg",
  dossier: "https://static.prod-images.emergentagent.com/jobs/a3a9839e-e55f-4496-972b-70597ef12d5c/images/e63142364cf41034513b55950a8868022d88c051c93bd5a4bbcf1f03ee1940c4.jpeg",
  steps: [
    "https://static.prod-images.emergentagent.com/jobs/a3a9839e-e55f-4496-972b-70597ef12d5c/images/e29fbd7db76d5c6e85c26c970a19813eeded17fa1d625ce7b59037839f6a07b7.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/a3a9839e-e55f-4496-972b-70597ef12d5c/images/9fcb8a063c91fd08900fb3fe305a3322b7b1e321222b429d7b89da29d561cfce.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/a3a9839e-e55f-4496-972b-70597ef12d5c/images/9f901f7233d5f69cdf3bd90e4cdfb149d4ffa270ae7f685e3d0bcd1296830bad.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/a3a9839e-e55f-4496-972b-70597ef12d5c/images/203ad803fc37477f9b0ae249cc550623fdcf29d9cd58efbd7d06ff548c80c157.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/a3a9839e-e55f-4496-972b-70597ef12d5c/images/8c58df182554c58710b693d91ca9fe342ed8c983ab7104dbb0921f6a7a636a66.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/a3a9839e-e55f-4496-972b-70597ef12d5c/images/1e4ae5f1a80ea5bbd33e6aea0cd298f9191816c3a7f17d8cb1fa3f70f87b9820.jpeg",
  ],
  lettering: "https://static.prod-images.emergentagent.com/jobs/a3a9839e-e55f-4496-972b-70597ef12d5c/images/68afaec2b4d2c18e7d0cb4cd5ef15fe6e64f8912df561f110da667c74fd01f24.jpeg",
  heart: "https://static.prod-images.emergentagent.com/jobs/a3a9839e-e55f-4496-972b-70597ef12d5c/images/6e54ebff65ca15e53dd82d1c298189422a3dacf3ad58d4c76659fdc4ac6e9d32.jpeg",
};

export const TOUR_KEY = "rea_walkthrough_completed";
export const CONSENT_KEY = "rea_consent_v1";
